
const formatMoney = function (t, e = simply.moneyFormat) {
    /* Shopify Money Format */
    function o(t, e) {
      return void 0 === t ? e : t
    }
    function i(t, e, i, r) {
      if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
        return 0;
      t = (t / 100).toFixed(e);
      var n = t.split(".");
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || this.money_format;
    switch (a.match(n)[1]) {
      case "amount":
        r = i(t, 2);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        r = i(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        r = i(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        r = i(t, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        r = i(t, 2, "'", ".")
    }
    return a.replace(n, r)
  };
  const generateUniqueId = function () {
    return "b_" + new Date().valueOf() + Math.random().toFixed(2).substring(2);
  };
  const setCookie = (cname, cValue, exDays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cValue + ";" + expires + ";path=/";
  };
 
class CartApi {
    getCartData = async () => {
      let cartData = await fetch('/cart.json');
      cartData = await cartData.json();
      return cartData;
    }
    changeCartCount = async (cartData) => {
      if (!cartData) {
        cartData = await this.getCartData();
      }
      let cartCountDiv = qsa('.cart-count-js');
      if (cartCountDiv.length === 0) {
        return;
      }
      cartCountDiv.forEach(item => {
        if (cartData.item_count == 0) {
          item.parentElement.classList.add('hidden');
        }
        else {
          item.parentElement.classList.remove('hidden');
        }
        if (cartData.item_count > 99) {
          item.innerText = "";
        }
        else {
          let cartCount = cartData.item_count;
          let bundle_child_items_length = 0;
          if(cartData.item_count != 0) {
            cartData?.items.forEach((item) => {
              if (
                item.properties &&
                item.properties["_type"] &&
                item.properties["_type"] === "child"
              ) {
                bundle_child_items_length = bundle_child_items_length + item.quantity;
              }
            });
            cartCount = cartCount - bundle_child_items_length;
            item.innerText = cartCount;
          }else {
            item.innerText = cartCount;
          }
        }
  
      });
    }
    updateSideCart = async () => {
      let res = await fetch('/?section_id=cart-drawer');
      res = await res.text();
      return res;
    }
    cartChange = async (data) => {
      try {
        let res = await fetch(routes.cartChangeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data),
        });
        res = await res.json();
        return { status: 0, data: res };
      }
      catch (e) {
        return { status: 1, error: e.message }
      }
  
    }
  }

let cartApi = new CartApi();

class GiftBox {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.init();
    this.productsList = [];
    this.variantList = [];
    this.total = parseInt(this.parent.getAttribute('data-total'));
    this.masterProductId = parseInt(this.parent.getAttribute('data-master-product'));
    window.giftBoxProductListAdd = (id, product) => {
      this.updateProduct(id, product);
    }
  }

  updateProduct = (id, product) => {
    if (!id) {
      return;
    }
    if (this.variantList.length === this.total) {
      return;
    }
    this.productsList.push(product);
    this.variantList.push(id);
    this.updateStickyBar();
  }

  updateStickyBar = () => {
    let parent = this.parent;
    let checkoutBtn = qs('.cart-button.button-wrapper .btn-primary', parent);
    let priceWrapper = qs('.cart-button.button-wrapper .total-price-wrapper', parent);
    if (this.variantList.length === this.total) {

      const totalPrice = this.productsList.reduce((total, item) => total + parseInt(item.product.price), 0);
      let comparePrice = `MRP: ${formatMoney(totalPrice).replace('.00', '')}`;
      qs('.compare-price', priceWrapper).innerHTML = comparePrice;

      checkoutBtn && checkoutBtn.classList.remove('disabled');
      priceWrapper && priceWrapper.classList.remove('d-none');
    } else {
      checkoutBtn && checkoutBtn.classList.add('disabled');
      priceWrapper && priceWrapper.classList.add('d-none');
    }
    let itemSelection = qs('.items-selection', parent);
    let itemBoxes = qsa('.item-box', itemSelection);
    itemBoxes.forEach((item, index) => {
      let productData = this.productsList[index];
      let rHtml = ``;
      let flag = false;
      if (productData) {
        flag = true;
        rHtml = `<img src="${productData.product.image}" alt="Item ${index + 1}" class="item-image">`
      } else {
        rHtml = `<div class="placeholder">${index + 1}</div>`
      }
      qs('.item-image', item).innerHTML = rHtml;
      flag ? qs('.item-content', item).classList.remove('no-image') : qs('.item-content', item).classList.add('no-image');
    });
  }

  clickEvent = () => {
    let parent = this.parent;
    let addToBox = qsa('.add-to-box-js', parent);
    addToBox.forEach(element => {
      element.addEventListener('click', (e) => {
        let that = e.currentTarget;
        let vId = that.getAttribute('data-vid');
        let pId = that.getAttribute('data-pid');
        let image = that.getAttribute('data-image');
        let price = that.getAttribute('data-price');
        let productData = {
          product: {
            id: pId,
            variant: vId,
            image: image,
            price: price
          }
        }
        this.updateProduct(vId, productData);
      })
    });

    let removeItem = qsa('.remove-item', parent);
    removeItem.forEach(element => {
      element.addEventListener('click', (e) => {
        let that = e.currentTarget;
        let index = parseInt(that.closest('.item-box').getAttribute('data-index')) - 1;
        if (index >= 0 && index < this.productsList.length) {
          this.productsList.splice(index, 1);
          this.variantList.splice(index, 1);
        }
        this.updateStickyBar();
      })
    });

    let addToCart = qs('.cart-button.button-wrapper button', parent);
    addToCart && addToCart.addEventListener('click', async (e) => {
      let that = e.currentTarget;
      if (that.classList.contains('disabled')) {
        return;
      }
      that.classList.add('btn-loading');
      let cartData = await cartApi.getCartData();
      if (cartData.items.length > 0) {
        const hasGiftBox = cartData.items.some((item) => item.properties && item.properties._giftBox === true);
        if (hasGiftBox) {
          that.classList.remove('btn-loading');
          this.productsList = [];
          this.variantList = [];
          this.updateStickyBar();
          toastMessage({ msg: "Gift box already in cart"},true)
          return;
        }
      }
      let formData = {
        items: [],
      };
      let uid = generateUniqueId();
      this.variantList.forEach(element => {
        formData.items?.push({
          id: element,
          quantity: 1,
          properties: {
            _type: "child",
            _bid: uid,
          }
        });
      });
      formData.items.push({
        id: this.masterProductId,
        quantity: 1,
        properties: {
          _type: "master",
          _giftBox: true,
          _bid: uid,
        }
      });
      window.addToCartFun(formData, () => {
        that.classList.remove('btn-loading');
        that.classList.add('disabled');
        window.checkProductLimit();
        window.checkSingleProductAddToCart();
        cartApi.changeCartCount();
        if (that.classList.contains('side-cart')) {
          window.dispatchCartJson();
          window.openSideCartFlag();
        } else if (that.classList.contains('shopify')) {
          window.location.href = "/checkout"
        } else if (that.classList.contains('gokwik')) {
          window.initiateGokwik();
        }
      })
    })
  }

  init = () => {
    this.clickEvent();
  }
}

new GiftBox(qs('.giftbox-section-wrapper-js'));